module.exports = __webpack_public_path__ + "img/PC_07.00ffa955.jpg";